import React from 'react';

class Error404 extends React.Component {

    render() {
        return (
            <div className="wrapper">
                <div className="container app-body center">
                    <h2 className="center">404!</h2>
                    <h4 className="center">A página não foi encontrada.</h4>
                    <br />
                    <a href="/">Ir para página inicial</a>
                </div>
            </div>
        );
    }
}

export default Error404;